import { Play } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { useT } from "@/lib/i18n";

const VideoTrio = () => {
  const t = useT();

  const videos = [
    {
      src: "/videos/evidencia-cientifica-yoga-oncologico.mp4",
      poster: "/videos/evidencia-cientifica-yoga-oncologico-poster.jpg",
      eyebrow: t("videoTrio.v1.eyebrow"),
      title: t("videoTrio.v1.title"),
      description: t("videoTrio.v1.desc"),
    },
    {
      src: "/videos/equilibrio-yoga-oncologico.mp4",
      poster: "/videos/equilibrio-yoga-oncologico-poster.jpg",
      eyebrow: t("videoTrio.v2.eyebrow"),
      title: t("videoTrio.v2.title"),
      description: t("videoTrio.v2.desc"),
    },
    {
      src: "/videos/props-yoga-oncologico.mp4",
      poster: "/videos/props-yoga-oncologico-poster.jpg",
      eyebrow: t("videoTrio.v3.eyebrow"),
      title: t("videoTrio.v3.title"),
      description: t("videoTrio.v3.desc"),
    },
  ];

  return (
  <section className="py-20 md:py-28 bg-charcoal text-ivory" data-testid="video-trio-onco">
    <div className="max-w-[1300px] mx-auto px-6 md:px-12 lg:px-16">
      <Reveal>
        <div className="max-w-2xl mb-14 md:mb-20">
          <p className="text-[11px] tracking-[0.32em] uppercase text-terracotta mb-5">
            {t("videoTrio.eyebrow")}
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
            {t("videoTrio.title1")} <span className="italic text-terracotta">{t("videoTrio.title2")}</span> <br className="hidden md:block" />
            {t("videoTrio.title3")}
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-ivory/70 font-light">
            {t("videoTrio.lead")}
          </p>
        </div>
      </Reveal>

      <div className="grid md:grid-cols-3 gap-8 md:gap-10">
        {videos.map((v, i) => (
          <Reveal key={v.src} delay={i * 0.12}>
            <article className="flex flex-col h-full" data-testid={`video-card-${i}`}>
              <div
                className="relative rounded-2xl overflow-hidden bg-black shadow-xl shadow-black/30 mb-6 group"
                style={{ aspectRatio: "9 / 16" }}
              >
                <video
                  src={v.src}
                  poster={v.poster}
                  controls
                  playsInline
                  preload="metadata"
                  className="w-full h-full object-cover"
                >
                  {t("videoTrio.videoFallback")}
                </video>
                <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-90 group-hover:opacity-0 transition-opacity">
                  <span className="w-14 h-14 rounded-full bg-terracotta/95 flex items-center justify-center shadow-lg">
                    <Play size={20} className="text-ivory translate-x-0.5" fill="currentColor" />
                  </span>
                </div>
              </div>
              <p className="text-[10px] tracking-[0.3em] uppercase text-terracotta mb-3">
                {v.eyebrow}
              </p>
              <h3 className="font-serif text-2xl md:text-[1.7rem] leading-[1.15] mb-3">
                {v.title}
              </h3>
              <p className="text-[15px] leading-relaxed text-ivory/65 font-light">
                {v.description}
              </p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};

export default VideoTrio;
